import { useToastStore } from '@/lib/toast'
import { CheckCircle2, XCircle, Info, X } from 'lucide-react'

export function Toaster() {
  const { toasts, remove } = useToastStore()
  if (toasts.length === 0) return null

  return (
    <div className="fixed bottom-20 left-1/2 z-50 flex w-full max-w-sm -translate-x-1/2 flex-col gap-2 px-4 lg:bottom-6">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-center gap-2 rounded-lg border px-4 py-3 text-sm shadow-lg ${
            t.type === 'success' ? 'border-green-200 bg-green-50 text-green-800' :
            t.type === 'error' ? 'border-red-200 bg-red-50 text-red-800' :
            'border-blue-200 bg-blue-50 text-blue-800'
          }`}
        >
          {t.type === 'success' && <CheckCircle2 className="h-4 w-4 shrink-0" />}
          {t.type === 'error' && <XCircle className="h-4 w-4 shrink-0" />}
          {t.type === 'info' && <Info className="h-4 w-4 shrink-0" />}
          <span className="flex-1">{t.message}</span>
          <button onClick={() => remove(t.id)} className="shrink-0 opacity-60 hover:opacity-100">
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  )
}
